import React from 'react';
import YearFilter from '../../../components/SearchFilters/filters/YearFilter';
import ListingStatusFilter from '../../../components/SearchFilters/filters/ListingStatusFilter';
import ConditionFilter from '../../../components/SearchFilters/filters/ConditionFilter';
import FuelTypeFilter from '../../../components/SearchFilters/filters/FuelTypeFilter';
import EnginePowerFilter from '../../../components/SearchFilters/filters/EnginePowerFilter';
import NumberOfEnginesFilter from '../../../components/SearchFilters/filters/NumberOfEnginesFilter';
import BeamFilter from '../../../components/SearchFilters/filters/BeamFilter';
import DraughtFilter from '../../../components/SearchFilters/filters/DraughtFilter';
import SaleClassFilter from '../../../components/SearchFilters/filters/SaleClassFilter';

const SecondaryFilters = () => {
  return (
    <>
      <YearFilter />
      <ListingStatusFilter />
      <SaleClassFilter />
      <ConditionFilter />
      <FuelTypeFilter />
      <NumberOfEnginesFilter />
      <EnginePowerFilter />
      <BeamFilter />
      <DraughtFilter />
    </>
  );
};

export default SecondaryFilters;
